import { normalizeLegacyMarkup } from '../shared/legacyTemplates';
import { handleSearch } from '../shared/commonSearchFunction';
import { initFacetedSearch } from './facetedSearch';

import '../../util/static/defaultlist.css';

normalizeLegacyMarkup('sv-facetedsearch-portlet');
initFacetedSearch();
handleSearch('sv-facetedsearch-portlet', true);
